export default __webpack_public_path__ + "static/media/NeueHaasUnicaW01-Light.5cf7cc09.woff";